
import { RecommendLotsModel } from '../models/RecommendLotsModel.js';
import { RecommendLotsView } from '../views/RecommendLotsView.js';

export class RecommendLotsController {
    constructor() {

        this.model = new RecommendLotsModel();
        this.view = new RecommendLotsView();

        this.model.subscribe(state => this.view.render(state));
    }
}